// Per-page renderer for "supplier-directory" — extracted from reportBuilder.js.
// Signature: async (api, doc, ctx) => { y, aiInsights, aiRecommendations }
import autoTable from 'jspdf-autotable';
import { NAVY, formatValue } from '../utils';
import { drawVerticalBarChart } from '../charts';

export async function renderSupplierDirectory(api, doc, ctx) {
  const { qs, filterDesc, cs, pw, page } = ctx;
  let y = ctx.y;
  let aiInsights = [];
  let aiRecommendations = [];

  const res = await api.get(`/suppliers?${qs}`);
  const suppliers = res.data || [];

  if (suppliers.length > 0) {
    autoTable(doc, {
      startY: y,
      head: [['Supplier', 'Category', 'Total Spend', 'Risk Score', 'Kraljic']],
      body: suppliers.slice(0, 30).map(s => [
        s.name, s.category || 'N/A',
        formatValue(s.total_spend || 0),
        String(s.risk_score || '-'),
        s.kraljic_classification || '-',
      ]),
      styles: { fontSize: 7 },
      headStyles: { fillColor: NAVY },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 8;

    const chartData = suppliers.slice(0, 10).map(s => ({ label: s.name, value: s.total_spend || 0 }));
    if (y > 180) { doc.addPage(); y = 15; }
    y = drawVerticalBarChart(doc, 14, y, pw - 28, 70, chartData, { title: 'Top Suppliers by Spend' });
  }

  return { y, aiInsights, aiRecommendations };
}
